import { Plugin } from '@leafer-ui/draw'
import './PathCorner'


Plugin.add('corner')